import { connect } from 'react-redux';

import { IState } from '../../store';
import { getAgentName, getProfileLink } from '../../utils/agent';
import { AgentPreview, IAgentPreviewProps } from './agentPreview';
import {
  IAgentReviewsSchema,
  IAgentSchema,
  INewObjectSchema,
  IOfferSchema,
} from '@cian/api-models/offer-card/v1/get-offer-data';

interface IStoreProps {
  agent: IAgentSchema | null;
  offer: IOfferSchema;
  newObject: INewObjectSchema | null;
  agentReviews: IAgentReviewsSchema | undefined | null;
}

type IOwnProps = Pick<IAgentPreviewProps, 'onClick'>;

const mapStateToProps = ({ offerData: { agent, agentReviews, offer, newObject } }: IState): IStoreProps => ({
  agent,
  offer,
  newObject,
  agentReviews,
});

const mergeProps = (storeProps: IStoreProps, {}, ownProps: IOwnProps): IAgentPreviewProps => {
  const { agent, offer, newObject, agentReviews } = storeProps;

  const developer = newObject ? newObject.developer : null;
  const link = getProfileLink(agent, offer, developer);
  const clickHandler = link === undefined ? undefined : ownProps.onClick;

  return {
    link,
    name: agent ? getAgentName(agent, offer) : undefined,
    avatar: (agent && agent.absoluteAvatarUrl) || '',
    agentReviews,
    isPrivateBroker: agent && agent.isPrivateBroker,
    isPro: agent && agent.isPro,
    onClick: clickHandler,
    showProTag: false,
    showIsPrivateBroker: false,
    showPhotoBorder: false,
    makeWhiteColor: false,
  };
};

export const AgentPreviewContainer = connect(mapStateToProps, () => ({}), mergeProps)(AgentPreview);
